<template>
  <div>
			<div class="navbar">
				<div class="nav_wrapper margin">
					<h4 class="title">游戏专区</h4>
			   </div>
			</div>
			<div class="game_jingpin margin">
					<h5 class="t_jp"><span>麻将精品</span></h5>
					<div class="show_jp">
						<ul>
							<!-- <li>
								<div class="img" v-on:mouseenter="showshadow(0)" v-on:mouseleave="hideshadow">
										<img src="../../images/gamecenter/xlmj.jpg"/>
										<transition name="fade">
										<div class="shadow-area" v-show='initindex==0'>
											<img class="ercode" align="align" src="../../images/gamecenter_ercode/ercode_xianlai.png"/>
											<div class="message">
												<span>游戏类型：麻将</span>
												<span>玩家评分：<i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i></span>
												<span><i class="icon_load"></i>200W+下载</span>
											</div>
									 </div>
									 </transition>
								</div>
								<div class="decp">
									 <div class="titl clearfix">
									 		<span class="left">闲来麻将</span>
									 		<span class="right">公众号：XLmajiang666</span>
									 </div>
									 <p class="cont">闲来湖南麻将是一款休闲类棋牌游戏。时尚简约的棋牌画面，真人实时对战玩法，陪伴您快乐每一天</p>

									<router-link to="/download_xl">
									  <button class="onload right">点击下载</button>
									</router-link>
								</div>
							</li>
							<li>
								<div class="img" v-on:mouseenter="showshadow(1)" v-on:mouseleave="hideshadow">
										<img src="../../images/gamecenter/scmj.png"/>
										<transition name="fade">
										<div class="shadow-area" v-show='initindex==1'>
											<img class="ercode" align="align" src="../../images/gamecenter_ercode/ercode_xmsc.png"/>
											<div class="message">
												<span>游戏类型：麻将</span>
												<span>玩家评分：<i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i></span>
												<span><i class="icon_load"></i>200W+下载</span>
											</div>
									 </div>
									 </transition>
								</div>
								<div class="decp">
									 <div class="titl clearfix">
									 		<span class="left">熊猫四川麻将</span>
									 		<span class="right">公众号：xmscmj666</span>
									 </div>
									 <p class="cont">四川麻将血战到底是成都及周边乃至整个四川盛行的麻将玩法。核心是打缺门，刮风下雨，计番，流局查大叫。</p>
									 <router-link to="/download_sc">
									 <button class="onload right">点击下载</button>
									 </router-link>
								</div>
							</li> -->
							<li>
								<div class="img" v-on:mouseenter="showshadow(2)" v-on:mouseleave="hideshadow">
										<img src="../../images/gamecenter/xlgd.png"/>
										<transition name="fade">
										<div class="shadow-area" v-show='initindex==2'>
											<img class="ercode" align="align" src="../../images/gamecenter_ercode/ercode_gd.png"/>
											<div class="message">
												<span>游戏类型：麻将</span>
												<span>玩家评分：<i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i></span>
												<span><i class="icon_load"></i>200W+下载</span>
											</div>
									 </div>
									 </transition>
								</div>
								<div class="decp">
									 <div class="titl clearfix">
									 		<span class="left">闲来广东麻将</span>
									 		<span class="right">公众号：XLguangdong</span>
									 </div>
									 <p class="cont">广东麻将玩法多样，趣味性十足，有家喻户晓的推倒胡、鸡平胡,还有深受麻友喜爱的鬼牌、买马等一系列趣味的玩法,让游戏玩法更加的多样。</p>
									  <router-link to="/download_gd">
									 <button class="onload right">点击下载</button>
									  </router-link>
								</div>
							</li>

							<li>
								<div class="img" v-on:mouseenter="showshadow(3)" v-on:mouseleave="hideshadow">
										<img src="../../images/gamecenter/sxmj.png"/>
										<transition name="fade">
										<div class="shadow-area" v-show='initindex==3'>
											<img class="ercode" align="align" src="../../images/gamecenter_ercode/ercode_sx.png"/>
											<div class="message">
												<span>游戏类型：麻将</span>
												<span>玩家评分：<i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i></span>
												<span><i class="icon_load"></i>100W+下载</span>
											</div>
									 </div>
									 </transition>
								</div>
								<div class="decp">
									 <div class="titl clearfix">
									 		<span class="left">闲来陕西麻将</span>
									 		<span class="right">公众号：xlsxmj666</span>
									 </div>
									 <p class="cont">陕西麻将是一个四个人才能玩的游戏。陕西麻将玩法简单、爽快，计算方便，而受到广大玩家欢迎。下炮子等特色玩法让游戏更加激烈刺激。</p>
									 <router-link to="/download_sx">
									 <button class="onload right">点击下载</button>
									 </router-link>
								</div>
							</li>
							<li>
								<div class="img" v-on:mouseenter="showshadow(4)" v-on:mouseleave="hideshadow">
										<img src="../../images/gamecenter/gzmj.png"/>
										<transition name="fade">
										<div class="shadow-area" v-show='initindex==4'>
											<img class="ercode" align="align" src="../../images/gamecenter_ercode/ercode_gz.png"/>
											<div class="message">
												<span>游戏类型：麻将</span>
												<span>玩家评分：<i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i></span>
												<span><i class="icon_load"></i>16W+下载</span>
											</div>
									 </div>
									 </transition>
								</div>
								<div class="decp">
									 <div class="titl clearfix">
									 		<span class="left">闲来贵州麻将</span>
									 		<span class="right">公众号：xlgz666</span>
									 </div>
									 <p class="cont">贵阳捉鸡麻将起源于“川麻将”。经过创新，增加了“捉鸡”、“通行证”、“金鸡”等特色元素,所以“贵阳川麻将”也叫“贵阳捉鸡麻将”。</p>
									  <router-link to="/download_gz">
									 <button class="onload right">点击下载</button>
									 </router-link>
								</div>
							</li>
							<li>
								<div class="img" v-on:mouseenter="showshadow(5)" v-on:mouseleave="hideshadow">
										<img src="../../images/gamecenter/gxmj.jpg"/>
										<transition name="fade">
										<div class="shadow-area" v-show='initindex==5'>
											<img class="ercode" align="align" src="../../images/gamecenter_ercode/ercode_gx.png"/>
											<div class="message">
												<span>游戏类型：麻将</span>
												<span>玩家评分：<i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i></span>
												<span><i class="icon_load"></i>100W+下载</span>
											</div>
									 </div>
									 </transition>
								</div>
								<div class="decp">
									 <div class="titl clearfix">
									 		<span class="left">山水广西麻将</span>
									 		<span class="right">公众号：ssgxmj666</span>
									 </div>
									 <p class="cont">山水广西麻将是款水墨风格主打广西省主流玩法的麻将游戏，现囊括了柳州、南宁、贵港、百色等城市主流玩法，其界面唯美...</p>
									 <router-link to="/download_gx">
									 <button class="onload right">点击下载</button>
									 </router-link>
								</div>
							</li>
							<li>
								<div class="img" v-on:mouseenter="showshadow(6)" v-on:mouseleave="hideshadow">
										<img src="../../images/gamecenter/gansumj.png"/>
										<transition name="fade">
										<div class="shadow-area" v-show='initindex==6'>
											<img class="ercode" align="align" src="../../images/gamecenter_ercode/ercode_gansu.png"/>
											<div class="message">
												<span>游戏类型：麻将</span>
												<span>玩家评分：<i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i></span>
												<span><i class="icon_load"></i>100W+下载</span>
											</div>
									 </div>
									 </transition>
								</div>
								<div class="decp">
									 <div class="titl clearfix">
									 		<span class="left">闲来甘肃麻将</span>
									 		<span class="right">公众号：xlgsmj666</span>
									 </div>
									 <p class="cont">闲来甘肃麻将是一个四个人才能玩的游戏。因其最流行的滑水玩法简单易学、而深受广大玩家欢迎。下鱼子等特色玩法更是让游戏刺激畅快。</p>
									 <router-link to="/download_gs">
									  <button class="onload right">点击下载</button>
									 </router-link>
								</div>
							</li>
							<li>
								<div class="img" v-on:mouseenter="showshadow(7)" v-on:mouseleave="hideshadow">
										<img src="../../images/gamecenter/ynmj.png"/>
										<transition name="fade">
										<div class="shadow-area" v-show='initindex==7'>
											<img class="ercode" align="align" src="../../images/gamecenter_ercode/ercode_yn.png"/>
											<div class="message">
												<span>游戏类型：麻将</span>
												<span>玩家评分：<i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i></span>
												<span><i class="icon_load"></i>100W+下载</span>
											</div>
									 </div>
									 </transition>
								</div>
								<div class="decp">
									 <div class="titl clearfix">
									 		<span class="left">山水云南麻将</span>
									 		<span class="right">公众号：ssynmj666</span>
									 </div>
									 <p class="cont">云南麻将的规则体系和历史发展源远流长，在不同地区也有不同的玩法。比如曲靖流行“飞小鸡”玩法，丽江地区流行“卡五心”玩法。</p>
									  <router-link to="/download_yn">
									  <button class="onload right">点击下载</button>
									  </router-link>
								</div>
							</li>
							<li>
								<div class="img" v-on:mouseenter="showshadow(8)" v-on:mouseleave="hideshadow">
										<img src="../../images/gamecenter/fjmj.jpg"/>
										<transition name="fade">
										<div class="shadow-area" v-show='initindex==8'>
											<img class="ercode" align="align" src="../../images/gamecenter_ercode/ercode_fj.png"/>
											<div class="message">
												<span>游戏类型：麻将</span>
												<span>玩家评分：<i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i></span>
												<span><i class="icon_load"></i>100W+下载</span>
											</div>
									 </div>
									 </transition>
								</div>
								<div class="decp">
									 <div class="titl clearfix">
									 		<span class="left">八闽福建麻将</span>
									 		<span class="right">公众号：bmfjmj666</span>
									 </div>
									 <p class="cont">八闽福建麻将是一款休闲类棋牌游戏。时尚简约的棋牌画面，真人实时对战玩法，陪伴您快了每一天！八闽福建麻将集合福建多个地区...</p>
									 <router-link to="/download_fj">
									 <button class="onload right">点击下载</button>
									 </router-link>
								</div>
							</li>
							<li>
								<div class="img" v-on:mouseenter="showshadow(9)" v-on:mouseleave="hideshadow">
										<img src="../../images/gamecenter/nxmj.jpg"/>
										<transition name="fade">
										<div class="shadow-area" v-show='initindex==9'>
											<img class="ercode" align="align" src="../../images/gamecenter_ercode/ercode_nx.png"/>
											<div class="message">
												<span>游戏类型：麻将</span>
												<span>玩家评分：<i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i></span>
												<span><i class="icon_load"></i>100W+下载</span>
											</div>
									 </div>
									 </transition>
								</div>
								<div class="decp">
									 <div class="titl clearfix">
									 		<span class="left">闲来宁夏麻将</span>
									 		<span class="right">公众号：xlnxmj666</span>
									 </div>
									 <p class="cont">闲来宁夏麻将是一个四个人才能玩的游戏。因其玩法简单、爽快，计算方便，而受到广大玩家欢迎。</p>
									 <router-link to="/download_nx">
									 <button class="onload right">点击下载</button>
									  </router-link>
								</div>
							</li>
							<li>
								<div class="img" v-on:mouseenter="showshadow(11)" v-on:mouseleave="hideshadow">
										<img src="../../images/gamecenter/anhuimj.png"/>
										<transition name="fade">
										<div class="shadow-area" v-show='initindex==11'>
											<img class="ercode" align="align" src="../../images/gamecenter_ercode/ercode_anhui.png"/>
											<div class="message">
												<span>游戏类型：麻将</span>
												<span>玩家评分：<i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i></span>
												<span><i class="icon_load"></i>4W+下载</span>
											</div>
									 </div>
									 </transition>
								</div>
								<div class="decp">
									 <div class="titl clearfix">
									 		<span class="left">闲来安徽麻将</span>
									 		<span class="right">公众号：xlahmj666</span>
									 </div>
									 <p class="cont">安徽麻将是款画面精美、操作简单的麻将。现主要包括“合肥”“安庆”“淮南”等特色玩法。还有风靡全国的红中赖子和推到胡玩法。</p>
									<router-link to="/download_anhui">
									<button class="onload right">点击下载</button>
									</router-link>
								</div>
							</li>


							<li>
								<div class="img" v-on:mouseenter="showshadow(15)" v-on:mouseleave="hideshadow">
										<img src="../../images/gamecenter/nmmj.png"/>
										<transition name="fade">
										<div class="shadow-area" v-show='initindex==15'>
											<img class="ercode" align="align" src="../../images/gamecenter_ercode/ercode_nm.png"/>
											<div class="message">
												<span>游戏类型：麻将</span>
												<span>玩家评分：<i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i></span>
												<span><i class="icon_load"></i>100W+下载</span>
											</div>
									 </div>
									 </transition>
								</div>
								<div class="decp">
									 <div class="titl clearfix">
									 		<span class="left">龙腾内蒙麻将</span>
									 		<span class="right">公众号：nmmj666</span>
									 </div>
									 <p class="cont">龙腾内蒙麻将是一款休闲棋牌游戏，真人对战实时约局，拥有最原汁原味的内蒙本地规则，让您无论身在何处都能玩到最纯正的内蒙麻将！</p>
									 <router-link to="/download_nm">
									 <button class="onload right">点击下载</button>
									 </router-link>

								</div>
							</li>



						</ul>
					  <!-- <h5 class="t_jp"><span>棋牌精品</span></h5>
						<ul>
							<li>
								<div class="img" v-on:mouseenter="showshadow(16)" v-on:mouseleave="hideshadow">
										<img src="../../images/gamecenter/ddzmj.png"/>
										<transition name="fade">
										<div class="shadow-area" v-show='initindex==16'>
											<img class="ercode" align="align" src="../../images/gamecenter_ercode/ercode_ddz.png"/>
											<div class="message">
												<span>游戏类型：棋牌</span>
												<span>玩家评分：<i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i></span>
												<span><i class="icon_load"></i>4W+下载</span>
											</div>
									 </div>
									 </transition>
								</div>
								<div class="decp">
									 <div class="titl clearfix">
									 		<span class="left">闲来斗地主</span>
									 		<span class="right">公众号：xlddz666</span>
									 </div>
									 <p class="cont">斗地主是纸牌游戏。是一种扑克游戏。该扑克游戏最初流行于中国湖北武汉市汉阳区，现已逐渐在各地流行。</p>
									 <router-link to="/download_ddz">
									 <button class="onload right">点击下载</button>
									 </router-link>
								</div>
							</li>
							<li>
								<div class="img" v-on:mouseenter="showshadow(17)" v-on:mouseleave="hideshadow">
										<img src="../../images/gamecenter/pdkmj.png"/>
										<transition name="fade">
										<div class="shadow-area" v-show='initindex==17'>
											<img class="ercode" align="align" src="../../images/gamecenter_ercode/ercode_pdk.png"/>
											<div class="message">
												<span>游戏类型：棋牌</span>
												<span>玩家评分：<i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i></span>
												<span><i class="icon_load"></i>22W+下载</span>
											</div>
									 </div>
									 </transition>
								</div>
								<div class="decp">
									 <div class="titl clearfix">
									 		<span class="left">闲来跑的快</span>
									 		<span class="right">公众号：xlpdk666</span>
									 </div>
									 <p class="cont">《闲来跑得快》是本公司倾力打造的跨平台棋牌游戏产品。精致的界面设计、丰富的产品功能，极小的安装包！</p>
									<router-link to="/download_pdk">
									<button class="onload right">点击下载</button>
									</router-link>
								</div>
							</li>
							<li>
								<div class="img" v-on:mouseenter="showshadow(18)" v-on:mouseleave="hideshadow">
										<img src="../../images/gamecenter/phzmj.png"/>
										<transition name="fade">
										<div class="shadow-area" v-show='initindex==18'>
											<img class="ercode" align="align" src="../../images/gamecenter_ercode/ercode_phz.png"/>
											<div class="message">
												<span>游戏类型：棋牌</span>
												<span>玩家评分：<i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i><i class="star"></i></span>
												<span><i class="icon_load"></i>22W+下载</span>
											</div>
									 </div>
									 </transition>
								</div>
								<div class="decp">
									 <div class="titl clearfix">
									 		<span class="left">闲来跑胡子</span>
									 		<span class="right">公众号：xlphz666</span>
									 </div>
									 <p class="cont">闲来游戏推出重度力作“闲来跑胡子”，画面精美，玩法正宗，更安全，更省流量。并且玩法多样，可创建房间与现实中好友畅快对决！</p>
									<router-link to="/download_phz">
									<button class="onload right">点击下载</button>
									</router-link>
								</div>
							</li>
							
						</ul> -->
					</div>

			</div>
  </div>
</template>

<script>
export default {
    data(){
        return{
        	showercode:false,
					initindex:-1
        }
    },
    components:{
    },
    methods: {
    	gotodetail:function(){
    		this.$router.push({ name: 'gamekinddetail'});
    	},
    	showshadow:function(index){
					this.initindex=index;
					this.showercode1=true;
    	},
    	hideshadow:function(){
    		this.initindex=-1;
    	}
    }
}
</script>

<style lang="scss" scoped>
	 @import './../style/mixin';
			.navbar{
					position: relative;
					width: 100%;
    			min-width: 1000px;
    			height:75px;
			    color: #fff;
			    background-color:#303030;
			    .nav_wrapper{
						position:relative;
						height:100%;
						background: url('../../images/navbar.png') no-repeat center center;
						.title{
							position:relative;
							padding:20px 0px 20px 20px;
							font-weight:bolder;
							font-size:26px;
							color:#fff;
						}
					  .title:before{
					    position: absolute;
					    top: 26px;
					    left:0px;
					    bottom: 1px;
					    display: inline-block;
					    content: '';
					    height:24px;
						  content:'';
					    border-left:4px solid #ffdb17;
					    margin-right:28px;
						}
			    }
			}
			.game_jingpin{
				padding-bottom:30px;
				.t_jp{
					padding:30px 0px 20px;
					text-align: center;
					span{
					position:relative;
					@include sc(18px, #333131);
					}
					span:before{
						position: absolute;
						top:50%;
						left:100px;
						display: inline-block;
						content:'';
						width:430px;
						border-top:1px solid #cccccc;
					}
					span:after{
						position: absolute;
						top:50%;
						right:100px;
						display: inline-block;
						content:'';
						width:430px;
						border-top:1px solid #cccccc;
					}
				}
				.show_jp{
					ul{
						font-size:0;
						&>li{
							display: inline-block;
							width:322px;
							position: relative;
							margin:0px 17px 17px 0;
							border:1px solid #cfcfcf;
							.img{
								position:relative;
								img{
									display: block;
									width:100%;
								}
							 .shadow-area{
							 	position:absolute;
							 	left:0;
							 	bottom:0;
								padding:33px 25px;
								width:100%;
								height:100%;
								@include fj(center);
								background-color:rgba(0,0,0,0.7);
				        &.fade-enter-active, &.fade-leave-active{
				          transition: all 1s linear;
				          opacity: 1;
				        }
				        &.fade-enter, &.fade-leave-active{
				          opacity:0;
				        }
								.ercode{
									width:86px;
									height:86px;
								}
								.message{
									flex:1;
									span{
										display:block;
										padding-left:20px;
										line-height:28px;
										text-align: left;
										@include sc(14px, #fff);
									}
									.star{
										display: inline-block;
								    width: 14px;
								    height: 14px;
								    background: url(../../images/sc_1.png) no-repeat -4px -35px;
								    margin-right:3px;
									}
									.icon_load{
										display: inline-block;
								    width: 20px;
								    height: 18px;
								    background: url(../../images/sc_1.png) no-repeat -27px -34px;
								    vertical-align:middle;
								    margin-right:5px;
									}
								}
							}
							}
							.decp{
								padding:10px;
								.titl{
									line-height:30px;
									.left{
										font-weight:bold;
										@include sc(18px, #383838);
									}
									.right{
										@include sc(12px, #a9a9a9);
									}
								}
								.cont{
									line-height: 22px;
									@include sc(14px, #a9a9a9);
								}
								.onload{
									padding:3px 12px;
									text-align: center;
									border:1px solid #a9a9a9;
									background-color: transparent;
									@include borderRadius(5px);
									@include sc(14px, #a9a9a9);
									margin: 15px 0;
									cursor:pointer;
								}
								.onload:hover{
									border:1px solid #ffbb17;
									@include sc(14px, #ffbb17);
								}
							}
						}
						&>li:nth-child(3n+0){
							margin-right:0;
						}
					}
				}
			}
</style>
